import {
    REQUEST_EDIT_TYPE_LIST_FETCHING,
    REQUEST_EDIT_TYPE_LIST_SUCCESS,
    REQUEST_EDIT_TYPE_LIST_FAILED,
} from "../services/Constants";
import { RequesEditTypeList } from "../types/requet_edit_type_list.type";
      
    export interface RequesEditTypeListState {
        result: RequesEditTypeList[];
        isFetching: boolean;
        isError: boolean;
    }
      
    const initialState: RequesEditTypeListState = {
        result: [],
        isFetching: false,
        isError: false,
    };
      
export default (state = initialState, { type, payload}: any) => {
    switch (type) {
        case REQUEST_EDIT_TYPE_LIST_FETCHING:
            return { ...state, result: [], isFetching: true, isError: true };
        case REQUEST_EDIT_TYPE_LIST_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        case REQUEST_EDIT_TYPE_LIST_FAILED:
            return { ...state, result: [], isFetching: false, isError: true };
        default:
            return state;
        }
    };
      